// extracted by mini-css-extract-plugin
module.exports = {"h2":"WeighingsChart_h2__1GmWR","zoomContainer":"WeighingsChart_zoomContainer__3XZCz","brushContainer":"WeighingsChart_brushContainer__2TI0i"};